import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Toasted from 'vue-toasted';
import frag from 'vue-frag'

Vue.config.productionTip = false;

Vue.use(Toasted, { position: 'bottom-center', duration: 3000, keepOnHover: true })
Vue.directive('frag', frag)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
